import { Link } from 'react-router-dom';
import ButtonOne from "../../../components/buttons/buttonOne";
import FadeUp from "../../../components/animations/FadeUp";
// import { SEO } from "../../../seo/keywords";

export default function Landing () {
    return (
        <div className="relative w-full h-full flex-col items-center justify-center">
            {/* object-cover fits the image in balance way */}
            <div className="relative w-full h-screen">
                <img
                    className="flex object-cover object-[80%] md:object-center items-center justify-center w-full h-full"
                    alt="Hands-on engineering kit for education robotics"
                    src="/pictures/landing_image.webp"
                />
            </div>

            {/* Dark overlay */}
            <div className="absolute inset-0 bg-white/50" />

            <FadeUp
                className="absolute top-[13rem] left-[10%] sm:left-[15%] md:left-[25%] font-semibold text-[1.5rem] md:text-[1.8rem] xl:text-[2rem] text-black"
            >
                <h1 className="leading-tight">
                    H.I.R.O Model TR-01-A
                </h1>
                <p className="font-bold">The New Standard In DIY Robotics</p>
                <p>
                    Click the button to check out our store!
                    {/* Now on Kickstarter! */}
                </p>
            </FadeUp>

            {/* TODO: Shop link to be added*/}
            <Link to="https://shop.takamorirobot.com" target="_blank" aria-label="Explore robotics kits and beginner robotics course content">
                <FadeUp delay={0.5} className="absolute top-[24rem] left-[10%] sm:left-[15%] md:left-[25%]">
                    <ButtonOne bgColor="#F32047">
                        {/* Subscribe */}
                        Click for more!
                    </ButtonOne>
                </FadeUp>
            </Link>
        </div>
    )
}